import {ChangeDetectorRef, Component, Input, OnInit, OnDestroy} from '@angular/core';
import {HttpErrorResponse, HttpStatusCode} from "@angular/common/http";
import {environment} from "projects/store/src/environments/environment";
import {forkJoin, Subscription} from "rxjs";
import {CustomMessageService, LocalStorageService, UtilService} from "library";
import {LocalStorageKey, Permission, Role} from "projects/store/src/app/enums";
import {UserData} from "projects/store/src/app/interfaces";
import {CommissionsService} from "projects/store/src/app/services/api/v1/commissions.service";
import {AuthService} from "projects/store/src/app/services/api/v1/auth.service";
import {UserService} from "projects/store/src/app/services/api/v1/user.service";
import {ActivatedRoute, Router} from "@angular/router";
import {
  continueRequest, newRequest, viewCatalog, preCreditRating, saleReports,
  storePaymentReports, searchPaymentRequest, thirdPartyPaymentRequest, searchRequest, generateRequest
} from "../../menuOptions";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {RequestService} from "projects/store/src/app/services/api/v1/request.service";
import {ResponseHttpError, OriginMessageError} from "library";
import { MacroFlowService } from 'projects/store/src/app/services/api/v1/macro-flow.service';
import { SalesWorkflowMacro } from "projects/store/src/app/enums";
import { TypeSalesFlow } from "projects/store/src/app/enums/type-sales-flow.enum";
import { TypeSales } from "projects/store/src/app/enums/type-sales.enum";
import { MenuEventService } from 'projects/store/src/app/services/menu-event.service';

const TXT_FLOW_SELECTOR_BOTH = 'Puedes continuar realizando la venta con la versión actual que ya conoces, o probar la nueva vista actualizada:';
const TXT_FLOW_SELECTOR_NEW = 'Puedes continuar realizando la venta con la nueva vista actualizada:';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit, OnDestroy {
  form: FormGroup;
  isLoading = false;
  country: any = environment.global.country;
  accordionVisible: boolean = false;
  accordionFlowVisible: boolean = false;
  value?: string;
  userId?: string;
  storeID? : string;
  userData!: UserData;
  data: any;
  selectedDate = new Date();
  year!: number;
  month!: number;
  loading: boolean = false;
  textColor?: string;
  textColorSecondary?: string;
  surfaceBorder? : string;
  listSales: any[] = [];
  basicOptionsSales: any;
  basicDataSales: any;
  commissions!: any[];
  updatedUser: boolean = false;
  visibleModalQR: boolean = false;
  visibleModalFlowSelector: boolean = false;
  visibleModalFlowSelectorNewRequest: boolean = false;
  visibleModalSelectedStore: boolean = false;
  visibleModalStoreList: boolean = false;
  visibleModalConfirmStore: boolean = false;
  fullPatchUrl: any;
  status: number | null = null;
  readonly STATUS_OK = HttpStatusCode.Ok;
  readonly STATUS_NOT_ACCEPTABLE = HttpStatusCode.NotAcceptable;
  tinyUrl: any;
  is_retry = false;
  isTabOpen = false;
  copied = false;
  typeSalesFlow: any;
  txtFlowSalesSelector: string = '';
  loadingGenerateLinkShort!: boolean
  modalDeliverySalesType = false;
  typeSales: any;
  @Input() labelBreadcrumb = 'Inicio';

  private salesFlowSelectionSubscription: Subscription = new Subscription();
  private newSalesFlowSelectionSubscription: Subscription = new Subscription();

  buttonOrderByRole: { [key: string]: string[] } = {
    [`${Role.manager}`]: ['reporteVenta', 'ReportePagosTienda', 'PrecalificacionCredito', 'Catalogo', 'nueva', 'continuar'],
    [`${Role.salesman}`]: ['nueva', 'continuar', 'Catalogo', 'PrecalificacionCredito'],
    [`${Role.cashier}`]: ['BuscarSolicitud', 'GenerarSolicitud', 'ReportePagosTienda'],
    [`${Role.salesman_cashier}`]: ['nueva', 'continuar', 'Catalogo', 'PrecalificacionCredito', 'BuscarSolicitud'],
    [`${Role.commercial_manager}`]: ['reporteVenta', 'ReportePagosTienda']
  };

  stores: any[] = [];
  selectedStore: string | null = null;
  loadingStores: boolean = false;
  loadingChangeStore: boolean = false;
  selectedStoreName: string = '';


  constructor(private commissionsService: CommissionsService,
              private customMessageService: CustomMessageService,
              protected utilService: UtilService,
              private authService: AuthService,
              private userService: UserService,
              private router: Router,
              private route: ActivatedRoute,
              private cdr: ChangeDetectorRef,
              private localStorageService: LocalStorageService,
              private requestService: RequestService,
              private macroFlowService: MacroFlowService,
              private menuEventService: MenuEventService) {
    this.form = new FormGroup({
      phone: new  FormControl('', Validators.required)
    })
    if( ! this.authService.isAuthenticated()) {
      let token = this.route.snapshot.queryParams['token'];
      console.log(token)
      if(token !== undefined) {
        this.router.navigate(['/login'], { queryParams: { token: token}})
      }else{
        this.router.navigate(['login'])
      }
    }else{
      this.userData = this.localStorageService.get(LocalStorageKey.data);
      this.userId = this.userData.user.id;
      this.storeID = this.userData.store?.id;
      this.typeSales = this.userData.store?.setting.type_sales;
      this.setDate(this.selectedDate);
      this.typeSalesFlow = <string[]>(this.userData.store?.setting?.type_sales_flow.split(',').length > 0 ? this.userData.store?.setting?.type_sales_flow.split(',') : [])
    }

    this.salesFlowSelectionSubscription = this.menuEventService.salesFlowSelection$.subscribe(() => {
      this.salesFlowSelection();
    });

    this.newSalesFlowSelectionSubscription = this.menuEventService.newSalesFlowSelection$.subscribe(() => {
      this.newSalesFlowSelection();
    });

    console.log(this.userData.store?.setting?.type_sales_flow)

  }

  ngOnInit() {
    if(this.authService.isAuthenticated()) {
      this.data = this.localStorageService.get(LocalStorageKey.data);
      this.load();
      this.loadSales();
      this.loadCommissions()
      const documentStyle = getComputedStyle(document.documentElement);
      this.textColor = documentStyle.getPropertyValue('--text-color');
      this.textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
      this.surfaceBorder = documentStyle.getPropertyValue('--surface-border');
    }


  }

  getStyle(buttonId: string) {
    const order = this.buttonOrderByRole[this.userData.user.role.code];
    const index = order.indexOf(buttonId);
    return index !== -1 ? { order: index } : { display: 'none' };
  }

  getClass(buttonId: string): string {
    const order = this.buttonOrderByRole[this.userData.user.role.code];
    const indexInOrder = order.indexOf(buttonId);

    return indexInOrder === 0 || indexInOrder === 1 ? 'highlight' : '';
  }



  load(){

    this.userService.get(this.userData.user.id).subscribe({
      next: (resp) => {
        if(resp.status === HttpStatusCode.Ok){
          this.localStorageService.set(LocalStorageKey.data, resp.body.data);
          this.userService.updatedUserSubject.next(true);
          this.updatedUser = true;
        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }

        this.utilService.disablePageLoading();
      },
      error: (error) => {
        this.customMessageService.responseNoticeHandler(error);
        this.utilService.disablePageLoading();
      },
    })

  }

  loadSales(){
    this.loading = true;
    this.commissionsService.getSalesOfUser(this.userData.user.id, this.month, this.year).subscribe({
      next: (resp) => {
        if (resp.status === HttpStatusCode.Ok) {
          this.listSales = resp.body.data.sales.by_brand;
          const labelsSales = this.listSales.map((company: { name: any }) => company.name);
          const dataSales: number[] = this.listSales.map((monto: { quantity: number }) => monto.quantity);
          this.graphData(labelsSales, dataSales);
        }else {
          this.customMessageService.responseNoticeHandler(resp);
        }
        this.loading = false;
      },
      error: (error) => {
        this.customMessageService.responseNoticeHandler(error);
        this.loading = false;
      }
    })
  }

  loadCommissions(){
    this.loading = true;
    const month = new Date().getMonth() + 1;
    const year = new Date().getFullYear();
    this.commissionsService.getCommisionsOfUser(this.userData.user.id, month, year).subscribe({
      next: (resp) => {
        if (resp.status === HttpStatusCode.Ok) {
          this.commissions = resp.body.data.list.slice(0, 4)
            .sort((a: any, b: any) => new Date(b.date).getTime() - new Date(a.date).getTime())
            .map((commision: any) => {
              commision.status = commision.status.replaceAll('_', ' ')
              return commision;
            });
        }else {
          this.customMessageService.responseNoticeHandler(resp);
        }
        this.loading = false;
      },
      error: (error) => {
        this.customMessageService.responseNoticeHandler(error);
        this.loading = false;
      }
    })

  }

  setDate(date: Date) {
    this.month = new Date(date).getMonth() + 1;
    this.year = new Date(date).getFullYear();
  }

  gotoSalesModule(link: string, formaVenta?: TypeSales) {
    if (newRequest.action){
      this.userService.get(this.userData.user.id).subscribe({
        next: (resp) => {
          if(resp.status === HttpStatusCode.Ok){
            newRequest.action!(link, this.authService, formaVenta);
          }else{
            this.customMessageService.responseError();
            this.utilService.disablePageLoading();
          }
        },
        error: (error) => {
          this.customMessageService.comunicationError();
          this.utilService.disablePageLoading();
        },
      })
    }
  }

  graphData(labels: any[], data: number[]) {
    this.basicDataSales = {
      labels: labels,
      datasets: [
        {
          data: data,
          backgroundColor: ['rgba(255, 6, 46, 0.2)', 'rgba(255, 6, 46, 0.2)', 'rgba(255, 6, 46, 0.2)', 'rgba(153, 102, 255, 0.2)'],
          borderColor: ['rgb(255, 6, 46)', 'rgb(255, 6, 46)', 'rgb(255, 6, 46)', 'rgb(255, 6, 46)'],
          borderWidth: 1
        }
      ]
    };
    this.basicOptionsSales = {
      maintainAspectRatio: false,
      aspectRatio: 0.9,
      plugins: {
        title: {
          display: true,
          text: 'Ventas por marca',
        },
        legend: {
          display: false,
          labels: {
            color: this.textColor,
          }
        }
      },
      scales: {
        y: {
          min: 0,
          max: Math.max(...this.listSales.map(q => q.quantity +1)),
          beginAtZero: true,
          ticks: {
            color: this.textColorSecondary,
            stepSize: 1
          },
          grid: {
            color: this.surfaceBorder,
            drawBorder: false
          },
          title: {
            display: true,
            text: 'Ventas',
            color: this.textColor,
          }
        },
        x: {
          ticks: {
            color: this.textColorSecondary
          },
          grid: {
            color: this.surfaceBorder,
            drawBorder: false
          },
          title: {
            display: true,
            text: 'Marca',
            color: this.textColor,
          }
        }
      }
    };
  }

  generateDirectLinkNew(storeId?: string) {
    const resolvedStoreId = storeId ?? this.storeID;

    this.loading = true;
    if (!resolvedStoreId) {
      console.warn('Store ID es inválido');
      return;
    }
    const payload = {
      store_id: resolvedStoreId,
      source: 'store'
    };

    const startToken = btoa(JSON.stringify(payload));
    const domain = window.location.origin;

    this.fullPatchUrl = `${domain}/ventas/${this.macroFlowService.getFlowByPositionInMacro(SalesWorkflowMacro['macro-gestion-cliente'], 0)}?start_token=${startToken}&type_sales=${TypeSales.tienda}`;

    window.location.href = this.fullPatchUrl;
  }

  generateDirectLinkExperanza(storeId?: string) {
    const resolvedStoreId = storeId ?? this.storeID;

    this.loading = true;
    if (!resolvedStoreId) {
      console.warn('Store ID es inválido');
      return;
    }
    const payload = {
      store_id: resolvedStoreId,
      source: 'store'
    };

    const startToken = btoa(JSON.stringify(payload));
    const domain = window.location.origin;

    this.fullPatchUrl = `${domain}/ventas/${this.macroFlowService.getFlowByPositionInMacro(SalesWorkflowMacro['macro-experanza'], 0)}?start_token=${startToken}&type_sales=${TypeSales.tienda}`;

    window.location.href = this.fullPatchUrl;
  }

  onStartDeliverySales(){
    this.modalDeliverySalesType = true;
  }

  showSalesTypeOption(salesType: string) {
    if(this.typeSalesFlow.includes(<any>TypeSalesFlow.actual) || this.typeSalesFlow.includes(<any>TypeSalesFlow.nuevo)) {
      switch (salesType) {
        case TypeSales.domicilio:
          return this.typeSales === TypeSales.domicilio || this.typeSales === TypeSales.ambas;
        case TypeSales.tienda:
          return this.typeSales === TypeSales.tienda || this.typeSales === TypeSales.ambas;
        default:
          return false;
      }
    }else{
      return false
    }
  }


  generateLink(storeId: string | undefined, isTypeSalesAddress?: boolean){
    this.loadingGenerateLinkShort = true;
    if (!storeId) {
      console.warn('Store ID es inválido');
      return;
    }
    const payload = {
      store_id: storeId,
      source: 'store'
    }

    const startToken = btoa(JSON.stringify(payload));
    const domain = window.location.origin;

    let flow = isTypeSalesAddress ? this.macroFlowService.getFlowByPositionInMacro(SalesWorkflowMacro['macro-venta-domicilio'], 0) : this.macroFlowService.getFlowByPositionInMacro(SalesWorkflowMacro['macro-autogestion-cliente'], 0);
    const typeSales = isTypeSalesAddress ? TypeSales.domicilio : TypeSales.tienda;

    this.fullPatchUrl = `${domain}/ventas/${flow}?start_token=${startToken}&type_sales=${typeSales}`;

    this.requestService.getTinyUrl(this.fullPatchUrl).subscribe({
      next: (resp) => {
        if (resp.status === HttpStatusCode.Ok) {
          this.tinyUrl = resp.body.data.tiny_url;
        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }
        this.loadingGenerateLinkShort = false;
        this.showModalQR();
      },
      error: (error: HttpErrorResponse) => {
        this.customMessageService.responseNoticeHandler(error);
        this.loadingGenerateLinkShort = false;
      }
    })

  }

  generateLinkExperanza(storeId: string | undefined) {
    this.loadingGenerateLinkShort = true;
    if (!storeId) {
      console.warn('Store ID es inválido');
      return;
    }
    const payload = {
      store_id: storeId,
      source: 'store'
    };

    const startToken = btoa(JSON.stringify(payload));
    const domain = window.location.origin;

    const flow = this.macroFlowService.getFlowByPositionInMacro(SalesWorkflowMacro['macro-experanza'], 0);

    this.fullPatchUrl = `${domain}/ventas/${flow}?start_token=${startToken}&type_sales=${TypeSales.domicilio}`;

    this.requestService.getTinyUrl(this.fullPatchUrl).subscribe({
      next: (resp) => {
        if (resp.status === HttpStatusCode.Ok) {
          this.tinyUrl = resp.body.data.tiny_url;
        } else {
          this.customMessageService.responseNoticeHandler(resp);
        }
        this.loadingGenerateLinkShort = false;
        this.showModalQR();
      },
      error: (error: HttpErrorResponse) => {
        this.customMessageService.responseNoticeHandler(error);
        this.loadingGenerateLinkShort = false;
      }
    });
  }

  showModalQR(){
    this.visibleModalQR = true;
    this.visibleModalFlowSelectorNewRequest = false;
  }

  onModalQRShow() {
    this.accordionVisible = false;
    setTimeout(() => {
      this.accordionVisible = true;
    }, 0);
  }

  onModalQRHide() {
    this.accordionVisible = false;
  }

  onModalFlowShow() {
    this.accordionFlowVisible = false;
    setTimeout(() => {
      this.accordionFlowVisible = true;
    }, 0);
  }

  onModalFlowHide() {
    this.accordionFlowVisible = false;
  }

  printQr() {
    const canvas = document.querySelector('#qr-code canvas') as HTMLCanvasElement;
    if (!canvas) {
      console.warn('No se encontró el canvas del QR');
      return;
    }

    const dataUrl = canvas.toDataURL();
    const printWindow = window.open('', '', '');

    if (printWindow) {
      printWindow.document.write(`
      <html lang="es">
        <head>
          <title>Krediya | QR para iniciar venta</title>
          <style>
            body {
              margin: 0;
              display: flex;
              justify-content: center;
              align-items: center;
              width: 100%;
              height: 100vh;
            }
            img {
              margin: 0 auto;
              width: 500px;
              height: 500px;
            }
          </style>
        </head>
        <body onload="window.print(); window.close();">
          <img src="${dataUrl}" alt="QR Code" />
        </body>
      </html>
    `);
      printWindow.document.close();
    }
  }

  salesFlowSelection() {
    this.visibleModalFlowSelector = false;
    if (this.typeSalesFlow.length === 1 && this.typeSalesFlow.includes(TypeSalesFlow.actual)) {
      this.gotoSalesModule('continuar');
    }else {
      this.router.navigate(['tiendas/ventas/reanudar-solicitud']);
    }
  }

  newSalesFlowSelection() {
    if (!this.userData.distributor?.setting?.change_store_enabled) {
      this.visibleModalFlowSelectorNewRequest = true;
      return;
    }

    this.requestService.getAll().subscribe({
      next: (resp) => {
        if (resp.status === HttpStatusCode.Ok && resp.body.data.length > 0) {
          this.visibleModalFlowSelectorNewRequest = true;
        } else {
          this.visibleModalSelectedStore = true;
        }
      },
      error: () => {
        this.visibleModalFlowSelectorNewRequest = true;
      }
    });
  }

  viewButtonQr(){
    // TODO se comenta solo para el funcionamiento del flujo Gestion-tienda Es Temporal
    // const flowType = this.userData.store.setting.type_sales_flow;
    // return flowType === 'ambos' || flowType === 'nuevo';
    return false;
  }

  sendSms(){
    this.isLoading = true;
    if( this.form.invalid){
      this.form.markAllAsTouched();
      this.isLoading = false;
      return;
    }

    const phoneClean = this.cleanPhone(this.form.value.phone);
    this.requestService.sendSmsForSale(phoneClean, this.is_retry, 'sms-link', this.tinyUrl).subscribe({
      next: (resp) => {
        if (resp.status === HttpStatusCode.NoContent) {
          this.status = resp.status;
        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }
        this.isLoading = false;
        this.is_retry = true;

      },
      error: (err: ResponseHttpError) => {
        if (err.status === HttpStatusCode.NotAcceptable) {
          this.status = err.status;
        }else{
          this.customMessageService.responseNoticeHandler(err);
          this.isLoading = false;
        }
        this.is_retry = true;
      }
    })

  }

  cleanPhone(phone:string){
    return phone?.replace(/^\+\d+\s?/, '')?.replace(/\D/g, '');
  }

  loadTinyUrl(){
    this.isLoading = true;
    this.requestService.getTinyUrl('').subscribe({
      next: (resp) => {
        if (resp.status === HttpStatusCode.Ok) {
          console.log(resp.body.data)
          this.tinyUrl = resp.body.data.url;
        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }
        this.isLoading = false;
      },
      error: (err: ResponseHttpError) => {
        this.isLoading = false;
        this.customMessageService.responseNoticeHandler(err);
      }
    })
  }

  copyToClipboard() {
    if (!this.tinyUrl) return; // Asegura que hay algo que copiar

    this.loading = true;
    this.copied = true;

    navigator.clipboard.writeText(this.tinyUrl).then(() => {
      setTimeout(() => {
        this.copied = false;
        this.loading = false;
        this.cdr.detectChanges();
      }, 2000); // tiempo de "copiando"
    }).catch(() => {
      this.loading = false;
      this.copied = false;
      this.cdr.detectChanges();
    });
  }

  showFlowSelectorItem(type: string) : boolean {
    switch(type){
      case TypeSalesFlow.actual:
        return this.typeSalesFlow.includes(TypeSalesFlow.actual);
      case TypeSalesFlow.nuevo:
        return this.typeSalesFlow.includes(TypeSalesFlow.nuevo);
      case TypeSalesFlow.online:
        return this.typeSalesFlow.includes(TypeSalesFlow.online);
      case TypeSalesFlow.experanza:
        return this.typeSalesFlow.includes(TypeSalesFlow.experanza);
      default:
        this.customMessageService.responseNoticeHandler({message: "Tipo de flujo desconocido:" + this.typeSalesFlow }, OriginMessageError.FRONTEND);
        return false;
    }
  }

  onConfirmCurrentStore() {
    this.visibleModalSelectedStore = false;
    this.visibleModalFlowSelectorNewRequest = true;
  }

  onSelectOtherStore() {
    this.visibleModalSelectedStore = false;
    this.loadingStores = true;
    const distributorId = this.userData.distributor?.id;
    if (!distributorId) return;

    this.commissionsService.getListStoreByDealer(distributorId).subscribe({
      next: (resp) => {
        if (resp.status === HttpStatusCode.Ok) {
          this.stores = resp.body.data.list;
        }
        this.loadingStores = false;
        this.selectedStore = null;
        this.visibleModalStoreList = true;
      },
      error: () => {
        this.customMessageService.comunicationError();
        this.loadingStores = false;
      }
    });
  }

  onCancelStoreSelection() {
    this.visibleModalStoreList = false;
  }

  onConfirmStoreSelection() {
    if (!this.selectedStore) return;
    const store = this.stores.find((s: any) => s.id === this.selectedStore);
    this.selectedStoreName = store ? store.name : '';
    this.visibleModalStoreList = false;
    this.visibleModalConfirmStore = true;
  }

  onCancelConfirmStore() {
    this.visibleModalConfirmStore = false;
    this.visibleModalStoreList = true;
  }

  onConfirmStoreChange() {
    if (!this.selectedStore || !this.userId) return;
    this.loadingChangeStore = true;

    this.userService.updateStore(this.userId, this.selectedStore).subscribe({
      next: (resp) => {
        if (resp.status === HttpStatusCode.NoContent || resp.status === HttpStatusCode.Ok) {
          this.userService.get(this.userId!).subscribe({
            next: (userResp) => {
              if (userResp.status === HttpStatusCode.Ok) {
                this.localStorageService.set(LocalStorageKey.data, userResp.body.data);
                this.userService.updatedUserSubject.next(true);
                window.location.reload();
                return;
              }
              this.loadingChangeStore = false;
              this.visibleModalConfirmStore = false;
            },
            error: () => {
              this.customMessageService.comunicationError();
              this.loadingChangeStore = false;
            }
          });
        } else {
          this.customMessageService.responseError();
          this.loadingChangeStore = false;
        }
      },
      error: () => {
        this.customMessageService.comunicationError();
        this.loadingChangeStore = false;
      }
    });
  }

  ngOnDestroy() {
    if (this.salesFlowSelectionSubscription) {
      this.salesFlowSelectionSubscription.unsubscribe();
    }
    if (this.newSalesFlowSelectionSubscription) {
      this.newSalesFlowSelectionSubscription.unsubscribe();
    }
  }

  get f(){
    return this.form.controls;
  }

  protected readonly Permission = Permission;
  protected readonly NuevaSolicitud = newRequest;
  protected readonly continueRequest = continueRequest;
  protected readonly viewCatalog = viewCatalog;
  protected readonly preCreditRating = preCreditRating;
  protected readonly saleReports = saleReports;
  protected readonly storePaymentReports = storePaymentReports;
  protected readonly searchPaymentRequest = searchPaymentRequest;
  protected readonly thirdPartyPaymentRequest = thirdPartyPaymentRequest;
  protected readonly searchRequest = searchRequest;
  protected readonly generateRequest = generateRequest;
  protected readonly TypeSales = TypeSales;
  protected readonly TypeSalesFlow = TypeSalesFlow;
}
